import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["href", "children", "target", "withArrow", "className"],
    _excluded2 = ["theme", "$styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import convertLayoutProps from '../../utils/convertLayoutProps';
import FocusTrap from '../focus-trap/FocusTrap';
import { arrowLinkVariants, colors, resetStyles, sizes, variants } from './Link.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var isAbsoluteLink = function isAbsoluteLink(href) {
  return href.indexOf('http') === 0;
};

var LinkText = styled.div.withConfig({
  displayName: "Link__LinkText",
  componentId: "sc-1wne7g-0"
})(["display:inherit;"]);
var LinkArrow = styled.span.withConfig({
  displayName: "Link__LinkArrow",
  componentId: "sc-1wne7g-1"
})(["&&:after{content:' \\2192';}[dir='rtl'] &&:after{content:' \\2190';}[dir='ltr'] &&:after{content:' \\2192';}"]);
var BaseLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var href = props.href,
      children = props.children,
      _props$target = props.target,
      target = _props$target === void 0 ? href && isAbsoluteLink(href) ? '_blank' : undefined : _props$target,
      _props$withArrow = props.withArrow,
      withArrow = _props$withArrow === void 0 ? false : _props$withArrow,
      className = props.className,
      restProps = _objectWithoutProperties(props, _excluded);

  var linkContents = children;

  if (withArrow) {
    linkContents = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LinkText, {
        className: "link-text",
        children: children
      }), /*#__PURE__*/_jsx(LinkArrow, {
        className: "link-arrow",
        "aria-hidden": "true"
      })]
    });
  }

  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    ref: ref,
    target: target,
    href: href,
    className: "".concat(className, " js__event-link") // we still need this class to support legacy code

  }, restProps), {}, {
    children: /*#__PURE__*/_jsx(FocusTrap, {
      as: "span",
      children: linkContents
    })
  }));
});
BaseLink.displayName = 'BaseLink';
/**
 * If you need Link that supports styling according to our design tokens
 */

var Link = styled(BaseLink).withConfig({
  displayName: "Link",
  componentId: "sc-1wne7g-2"
})(["", " ", " ", " ", " ", ";", ""], function (props) {
  return props.theme.normalizeStyles(resetStyles);
}, function (_ref) {
  var theme = _ref.theme,
      $variant = _ref.$variant,
      withArrow = _ref.withArrow;
  return $variant && (withArrow ? theme.expandVariants($variant, arrowLinkVariants) : theme.expandVariants($variant, variants));
}, function (_ref2) {
  var theme = _ref2.theme,
      $size = _ref2.$size;
  return $size && theme.expandVariants($size, sizes);
}, function (_ref3) {
  var theme = _ref3.theme,
      $color = _ref3.$color;
  return $color && theme.expandVariants($color, colors);
}, function (_ref4) {
  var theme = _ref4.theme,
      $styles = _ref4.$styles,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return theme.normalizeStyles(_objectSpread(_objectSpread({}, convertLayoutProps(props)), $styles));
}, function (_ref5) {
  var $nowrap = _ref5.$nowrap;
  return $nowrap && css(["white-space:nowrap;"]);
});
Link.displayName = 'Link';
export default Link;